import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

interface ITextInputStyled {
  isError?: boolean;
  disabled?: boolean;
}

export const TextInputStyled = styled(Box)<ITextInputStyled>(({ theme, disabled }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',

  '& label': {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px',
    color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    marginBottom: '4px',

    '& span': {
      color: 'red',
      marginLeft: '2px',
    },
  },

  '& h6': {
    position: 'relative',
    marginTop: '4px',
    marginBottom: 0,
    lineHeight: '14px',
    color: '#d32f2f',
    fontSize: '12px',
    textAlign: 'left',
    fontWeight: 400,
  },
}));
